import React from 'react';

const base = process.env.PUBLIC_URL || '';

export function ProjectsSection() {
  return (
    <section id="projecten" className="section-projecten" aria-label="Projecten">
      <h2>Projecten</h2>
      <div className="projecten-grid">
        <a
          href="https://www.qb-engineering.nl/"
          target="_blank"
          rel="noopener noreferrer"
          className="project-tile"
          title="QB Engineering – open in nieuw tabblad"
        >
          <img src={`${base}/images/home/qbengineering.png`} alt="QB Engineering" />
        </a>
      </div>
    </section>
  );
}

